import * as React from 'react';
import {
  AsyncProcess,
  createAsyncProcess,
  createAsyncProcessConstructor,
} from 'utils/asyncProcessUtils';
import { useSafeAsyncWrapper } from './useSafeAsyncWrapper';

export function useAsyncController<ValueType>() {
  const actualProcessIdRef = React.useRef(0);

  const [asyncProcess, setAsyncProcess] = React.useState<
    AsyncProcess<ValueType>
  >(createAsyncProcess);

  const wrapAsyncSafely = useSafeAsyncWrapper();

  const wrapAsync = React.useCallback(
    (promise: Promise<ValueType | Error>) => {
      actualProcessIdRef.current = actualProcessIdRef.current + 1;

      const { current: processId } = actualProcessIdRef;

      setAsyncProcess(
        createAsyncProcessConstructor(
          createAsyncProcess<ValueType>()
        ).toPending()
      );

      wrapAsyncSafely(
        promise.then((value) => {
          if (processId === actualProcessIdRef.current) {
            if (value instanceof Error) {
              setAsyncProcess((prev) =>
                createAsyncProcessConstructor(prev).toRejected(value)
              );
            } else {
              setAsyncProcess((prev) =>
                createAsyncProcessConstructor(prev).toResolved(value)
              );
            }
          }
        })
      );
    },
    [wrapAsyncSafely]
  );

  return { asyncProcess, wrapAsync };
}
